import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SupportService } from "../services/support-service";
import { AppService } from "../services/app.service";

@Component({
  selector: "app-metro",
  templateUrl: "./metro.component.html",
})
export class MetroComponent implements OnInit {
  countryCode: any = "US";
  stateList: any = [];
  path: any;

  constructor(
    private router: Router,
    private supportService: SupportService,
    private appService: AppService
  ) {}

  ngOnInit() {
    this.path = this.router.url;
    const splitpath = this.path.split("/");
    if (splitpath && splitpath.length === 3) {
      this.countryCode = splitpath[2];
      this.getallstatecount();
    } else {
      this.supportService.countryCode.subscribe((res) => {
        if (res) {
          this.countryCode = res;
          this.getallstatecount();
        }
      });
    }
  }

  getallstatecount() {
    const data = {
      countryCode: this.countryCode,
    };
    this.appService.getallstatecount(data).subscribe((res) => {
      if (
        res &&
        res["status"] &&
        res["status"]["status"] &&
        res["status"]["status"] === 200
      ) {
        this.stateList = res["entity"];
      }
    }, (err) => {
      console.log(err);
    });
  }

  goToHome() {
    this.router.navigate(["/home"]);
  }

  goToRegion(stateId) {
    this.supportService.stateId.next(stateId);
    this.router.navigate(["/region", stateId]);
  }
}
